



















import { JournalEntry } from "../../models/JournalEntry";

export default {
    name: "CommentsCount",
    props: {
        entry: JournalEntry,
    },
};
